import Base from './Base'
import gsap from 'gsap'
import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';

import { evt, utils, store } from '@/core'

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted();
		console.log('Entra')

		const btnRating = qsa('.block-servicio_ratings')
    
		btnRating &&
		btnRating.forEach(el => {
			el.addEventListener('click', () =>{
				el.classList.toggle('open')
			})
		});
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
}